export default {
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    _f: String.fromCharCode,
    decompressFromBase64: function (input) {
        if (input == null) return "";
        var output = "",
            ol = 0,
            output_ = null,
            chr1, chr2, chr3,
            enc1, enc2, enc3, enc4 = 0,
            i = 0,
            f = this._f;

        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length) {
            enc1 = this._keyStr.indexOf(input.charAt(i++));
            enc2 = this._keyStr.indexOf(input.charAt(i++));
            enc3 = this._keyStr.indexOf(input.charAt(i++));
            enc4 = this._keyStr.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            if (ol % 2 == 0) {
                output_ = chr1 << 8;
                if (enc3 != 64) {
                    output += f(output_ | chr2);
                }
                if (enc4 != 64) {
                    output_ = chr3 << 8;
                }
            } else {
                output += f(output_ | chr1);
                if (enc3 != 64) {
                    output_ = chr2 << 8;
                    output += f(output_ | chr3);
                }
            }
            ol += 3;
        }
        return this.decompress(output);
    },
    decompress: function (compressed) {
        if (compressed == null) return "";
        if (compressed == "") return null;

        var dictionary = [],
            enlargeIn = 4,
            dictSize = 4,
            numBits = 3,
            entry = "",
            result = [],
            w,
            bits, resb, maxpower, power,
            c,
            data = {
                string: compressed,
                val: compressed.charCodeAt(0),
                position: 32768,
                index: 1
            },
            f = this._f,
            i;

        for (i = 0; i < 3; i += 1) {
            dictionary[i] = i;
        }

        bits = 0;
        maxpower = Math.pow(2, 2);
        power = 1;
        while (power != maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
                data.position = 32768;
                data.val = data.string.charCodeAt(data.index++);
            }
            bits |= (resb > 0 ? 1 : 0) * power;
            power <<= 1;
        }

        switch (c = bits) {
            case 0:
                bits = 0;
                maxpower = Math.pow(2, 8);
                power = 1;
                while (power != maxpower) {
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = 32768;
                        data.val = data.string.charCodeAt(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                c = f(bits);
                break;
            case 1:
                bits = 0;
                maxpower = Math.pow(2, 16);
                power = 1;
                while (power != maxpower) {
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = 32768;
                        data.val = data.string.charCodeAt(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                c = f(bits);
                break;
            case 2:
                return "";
        }

        dictionary[3] = w = c;
        result.push(w);

        while (true) {
            if (data.index > data.string.length) {
                return "";
            }

            bits = 0;
            maxpower = Math.pow(2, numBits);
            power = 1;
            while (power != maxpower) {
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = 32768;
                    data.val = data.string.charCodeAt(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }

            switch (c = bits) {
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while (power != maxpower) {
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = 32768;
                            data.val = data.string.charCodeAt(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    dictionary[dictSize++] = f(bits);
                    c = dictSize - 1;
                    enlargeIn--;
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while (power != maxpower) {
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = 32768;
                            data.val = data.string.charCodeAt(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    dictionary[dictSize++] = f(bits);
                    c = dictSize - 1;
                    enlargeIn--;
                    break;
                case 2:
                    return JSON.parse(result.join(""));
            }

            if (enlargeIn == 0) {
                enlargeIn = Math.pow(2, numBits);
                numBits++;
            }

            if (dictionary[c]) {
                entry = dictionary[c];
            } else {
                if (c === dictSize) {
                    entry = w + w.charAt(0);
                } else {
                    return null;
                }
            }
            result.push(entry);

            dictionary[dictSize++] = w + entry.charAt(0);
            enlargeIn--;

            w = entry;

            if (enlargeIn == 0) {
                enlargeIn = Math.pow(2, numBits);
                numBits++;
            }
        }
    },
    parseQuizData: function (data) {
        const parsedData = {
            lastViewedSlide: data.p.lastViewedSlide,
            viewDuration: data.p.viewDuration,
            slides: {},
        };

        Object.entries(data.p.slideStates).forEach(([slideNum, slide]) => {
            const slideData = {
                completed: slide.completed,
                visited: slide.visited,
            };

            // Если слайд содержит данные викторины
            if (slide.quizState) {
                const quizState = slide.quizState.S;
                const quizInfo = slide.quizInfo;

                slideData.quiz = {
                    type: quizInfo.type,
                    state: quizInfo.state,
                    passed: quizInfo.passed,
                    attempts: quizInfo.attempts,
                    questions: quizState.sp.q.map((qNum, idx) => {
                        const questionData = quizState.sp.g[0].s[qNum];
                        return {
                            question: qNum,
                            score: questionData.s,
                            correct: Object.entries(questionData.c).some(
                                ([, answer]) => answer.s === 1
                            ),
                            chosenAnswers: Object.entries(questionData.c)
                                .filter(([, answer]) => answer.s === 1)
                                .map(([ansNum]) => ansNum),
                        };
                    }),
                };
            }

            parsedData.slides[slideNum] = slideData;
        });

        return parsedData;
    },
    transformPayloadToRes: function (payload, onlyLastSlide) {
        // console.log('transformPayloadToRes 1: ', {payload, onlyLastSlide})
        let quizSlides = []
        if (onlyLastSlide) {
            quizSlides = Object.values(payload.slides).filter(el => el.quiz)
        }
        // console.log('transformPayloadToRes 2: ', {payload, onlyLastSlide, quizSlides})
        const res = {};
        let interactionIndex = 0;

        // Перебираем все слайды
        let count = 0
        Object.values(payload.slides).forEach(slide => {
            if (slide.quiz && slide.quiz.questions) {
                count = count + 1
                // Перебираем вопросы викторины на текущем слайде
                slide.quiz.questions.forEach(question => {
                    if (onlyLastSlide) {
                        if (count === quizSlides.length) {
                            res[`cmi.interactions.${interactionIndex}.result`] = question.correct ? "correct" : "wrong";
                            interactionIndex++;
                        }
                    } else {
                        res[`cmi.interactions.${interactionIndex}.result`] = question.correct ? "correct" : "wrong";
                        interactionIndex++;
                    }
                });
            }
        });
        // console.log('transformPayloadToRes 3: ', {payload, onlyLastSlide, res})
        return res;
    },

    getInteractionsResult2004: function (data) {
        const result = {};
        // Пробегаем по всем слайдам в "slideStates"
        let counter = 0
        Object.keys(data.p.slideStates).forEach(slideId => {
            const slide = data.p.slideStates[slideId];
            // Если существует quizInfo и поле passed, определяем результат
            if (slide.quizInfo && slide.quizInfo.hasOwnProperty('passed')) {
                result[`cmi.interactions.${slideId}.result`] = slide.quizInfo.passed ? 'correct' : 'wrong';
            }
        });

        return result;
    },
    removeCmiInteractionsFields:function (obj) {
        const result = {};

        for (const key in obj) {
            if (!key.startsWith("cmi.interactions.")) {
                result[key] = obj[key];
            }
        }

        return result;
    }
};